<template>
  <div class="cooperativedetail">
    <div class="flex-box">
      <div class="content-box">
        <div class="title">基本信息</div>
        <div class="info">
          <label>商单标题：</label>
          <span>{{ cpx_order.cpx_order_name }}</span>
        </div>
        <div class="info">
          <label>商品图片：</label>
          <img :src="goodsInfo.goods_img" />
        </div>
        <div class="info">
          <label>商品链接：</label>
          <span>
            <el-link class="treatment"
              type="primary" 
              :underline="false"
              :href="goodsInfo.goods_link"
              target='_blank'>{{ goodsInfo.goods_link }}</el-link>
          </span>
        </div>
        <div class="info">
          <label>商品名称：</label>
          <span>{{ goodsInfo.goods_name }}</span>
        </div>
        <div class="info">
          <label>商城：</label>
          <span>{{ platformObj[goodsInfo.platform] }}</span>
        </div>
        <div class="info">
          <label>品牌：</label>
          <span>{{ goodsInfo.brand_name }}</span>
        </div>
        <div class="info">
          <label>类目：</label>
          <span>
            <span>{{ goodsInfo.smzdm_category_1_name }}</span>
            <span v-if="goodsInfo.smzdm_category_2_name">/{{ goodsInfo.smzdm_category_2_name }}</span>
            <span v-if="goodsInfo.smzdm_category_3_name">/{{ goodsInfo.smzdm_category_3_name }}</span>
          </span>
        </div>
        <div class="info">
          <label>商品ID：</label>
          <span>{{ goodsInfo.goods_id }}</span>
        </div>
        <div class="info">
          <label>店铺：</label>
          <span>{{ goodsInfo.store_name }}</span>
        </div>
        <div class="info">
          <label>店铺dsr评分：</label>
          <span>
            <div v-if="goodsInfo.platform == 'taobao' || goodsInfo.platform == 'tianmao'">
              <div>【描述】{{ goodsInfo.merchant_score.evaluate_score }}</div>
              <div>【服务】{{ goodsInfo.merchant_score.service_score }}</div>
              <div>【物流】{{ goodsInfo.merchant_score.logistics_score }}</div>
            </div>
            <div v-if="goodsInfo.platform == 'jingdong'">
              <div>【商品】{{ goodsInfo.merchant_score.evaluate_score }}</div>
              <div>【售后】{{ goodsInfo.merchant_score.service_score }}</div>
              <div>【物流】{{ goodsInfo.merchant_score.logistics_score }}</div>
            </div>
          </span>
        </div>
        <div class="info">
          <label>商品规格：</label>
          <span>{{ goodsInfo.specifications }}</span>
        </div>
        <div class="info">
          <label>生产日期及保质期：</label>
          <span>{{ goodsInfo.product_expire_time }}</span>
        </div>
        <div class="info">
          <label>日常售价：</label>
          <span>{{ goodsInfo.daily_price }}</span>
        </div>
        <div class="info">
          <label>近30天销量：</label>
          <span>{{ goodsInfo.month_num }}</span>
        </div>
        <div class="info">
          <label>是否包邮：</label>
          <span>{{ goodsInfo.is_postage == 1 ? '包邮' : '不包邮' }}</span>
        </div>
        <div class="info">
          <label>商品库存：</label>
          <span>{{ goodsInfo.max_inventory ? goodsInfo.max_inventory : 0 }} 件</span>
        </div>
        <div class="info">
          <label>产品买点：</label>
          <span>{{ goodsInfo.recommendation_reason }}</span>
        </div>
      </div>
      <div class="content-box">
        <div style="margin-bottom: 20px">
          <div class="title">本次合作信息</div>
          <div class="info">
            <label>是否团长合作：</label>
            <span>{{ goodsInfo.is_head_coop == 1 ? '否' : '是' }}</span>
          </div>
          <div class="info" v-if="goodsInfo.is_head_coop == 2">
            <label>团长类型：</label>
            <span v-if="goodsInfo.article_head_type==1">普通团长</span>
            <span v-if="goodsInfo.article_head_type==2">内容团长</span>
          </div>
          <div class="info">
            <label>可供样品数：</label>
            <span>{{ goodsInfo.sample_number ? goodsInfo.sample_number : 0 }}</span>
          </div>
          <div class="info">
            <label>样品是否需要寄回：</label>
            <span>{{ goodsInfo.is_retrieve_sample == 1 ? '否' : '是' }}</span>
          </div>
          <div class="info" v-if="goodsInfo.is_retrieve_sample == 2">
            <label>样品寄回地址</label>
            <span>{{ goodsInfo.name }} {{ goodsInfo.tel }} {{ goodsInfo.back_address }}</span>
          </div>
          <div class="info">
            <label>达人专属价：</label>
            <span>{{ goodsInfo.kol_special_price }}元</span>
          </div>
          <div class="info">
            <label>折扣方式：</label>
            <span>
              <span v-if="goodsInfo.discount_model == 2">直降</span>
              <span v-if="goodsInfo.discount_model == 3">满减</span>
              <span v-if="goodsInfo.discount_model == 4">优惠券</span>
              <span v-if="goodsInfo.discount_model == 5">优惠券+满减</span>
              (<span v-if="goodsInfo.discount_model == 4 || goodsInfo.discount_model == 5">优惠券金额{{ goodsInfo.coupon_money }}元</span>
              <span v-if="goodsInfo.discount_model == 5 && goodsInfo.coupon_full">，</span>
              <span v-if="(goodsInfo.discount_model == 3 || goodsInfo.discount_model == 5) && goodsInfo.coupon_full">满{{ goodsInfo.coupon_full }}元减{{ goodsInfo.coupon_subtract }}元</span>）
            </span>
          </div>
          <div class="info">
            <label>佣金比例：</label>
            <span v-if="goodsInfo.commission_rate">{{ Number(goodsInfo.commission_rate) }}%</span>
          </div>
          <div class="info">
            <label>商单预计推广时间：</label>
            <span v-if="cpx_order.expect_begin_time && cpx_order.expect_end_time">{{ cpx_order.expect_begin_time.slice(0,10) }} 至 {{ cpx_order.expect_end_time.slice(0,10) }}</span>
          </div>
          <div class="info" v-if="goodsInfo.is_head_coop == 2">
            <label>实际团长活动时间：</label>
            <span v-if="goodsInfo.reality_begin_time && goodsInfo.reality_end_time">{{ goodsInfo.reality_begin_time.slice(0,10) }} 至 {{ goodsInfo.reality_end_time.slice(0,10) }}</span>
          </div>
          <div class="info" v-if="goodsInfo.is_head_coop == 2">
            <label>实际佣金比例：</label>
            <span>{{ goodsInfo.settlement_commission_rate }}%</span>
          </div>
          <div class="info">
            <label>达人专属福利：</label>
            <span>{{ goodsInfo.specific_benefits }}</span>
          </div>
        </div>
        <div>
          <div class="title">其他信息</div>
          <div class="info">
            <label>审核状态：</label>
            <span class="p-warning" v-if="goodsInfo.check_status == 1">待审核</span>
            <span class="p-color-succ" v-if="goodsInfo.check_status == 2">审核通过</span>
            <span class="p-color-danger" v-if="goodsInfo.check_status == 3">拒绝
              <el-tooltip placement="top">
                <div slot="content" class="w-500">{{ goodsInfo.refuse_reason }}</div>
                <i class="p-color-danger el-icon-question"></i>
              </el-tooltip>
            </span>
            <span class="p-warning" v-if="goodsInfo.check_status == 4">待分配</span>
          </div>
          <div class="info">
            <label>上下架状态：</label>
            <span v-if="goodsInfo.check_down == 1" class="p-color-succ">上架</span>
            <span v-if="goodsInfo.check_down == 2" class="p-color-danger">下架</span>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title">带货任务</div>
      <el-table
        :data="cpx_kol_user"
        :header-cell-style="{background: '#f9f9f9', color: '#333', fontSize: '14px', fontWeight: 'normal'}"
        :cell-style="{color:'#666', fontSize: '14px'}">
        <el-table-column label="达人昵称">
          <template slot-scope="scope">
            <div>【{{ scope.row.type_name }}】{{ scope.row.kol_user_name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="带货方式">
          <template slot-scope="scope">
            <div v-if="scope.row.promote_video == 2">短视频</div>
            <div v-if="scope.row.promote_live == 2">直播混播</div>
            <div v-if="scope.row.promote_live_special == 2">直播专场</div>
            <div v-if="scope.row.promote_other == 2">其他(图文等)</div>
          </template>
        </el-table-column>
        <el-table-column label="带货任务状态">
          <template slot-scope="scope">
            <span class="p-color-succ" v-if="scope.row.check_status == 1">合作成功</span>
            <span class="p-color-danger" v-if="scope.row.check_status == 2">合作失败</span>
            <span class="p-color-succ" v-if="scope.row.check_status == 3">待审核</span>
            <span class="p-color-succ" v-if="scope.row.check_status == 4">待发货</span>
            <span class="p-color-succ" v-if="scope.row.check_status == 5">待收货</span>
            <span class="p-color-succ" v-if="scope.row.check_status == 6">待交付</span>
            <span class="p-color-succ" v-if="scope.row.check_status == 7">交付待确认</span>
            <span class="p-color-danger" v-if="scope.row.check_status == 8">已拒绝</span>
            <span class="p-color-danger" v-if="scope.row.check_status == 10">已取消</span>
            <span class="p-color-succ" v-if="scope.row.check_status == 11">待填写寄样信息</span>
          </template>
        </el-table-column>
        <el-table-column label="商单标题">{{ cpx_order.cpx_order_name }}</el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "cooperativedetail",
  data() {
    return {
      goodsInfo: {},
      cpx_order: {},
      cpx_kol_user: [],
      platformObj: {
        taobao: "淘宝",
        jingdong: "京东",
        tianmao: "天猫",
        suning: "苏宁",
        kaola: "考拉",
        douyin: "抖音小店",
        weipinhui: "唯品会",
        wangyiyanxuan: "网易严选"
      },
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this
        .$http({
          method: "GET",
          url: "/home/getCooperationCpxGoodsDetail",
          params: {
            kolgsid: this.$route.query.kolgsid
          }
        })
        .then(res => {
          if (res.code === 1) {
            this.goodsInfo = res.data || {};
            this.cpx_order = res.data.cpx_order;
            this.cpx_kol_user = res.data.cpx_kol_user;
          } else {
            this.goodsInfo = {};
            this.cpx_order = {};
            this.cpx_kol_user = [];
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
}
</script>

<style scoped>
.cooperativedetail {
  color: #666;
  font-size: 14px;
}
.flex-box {
  display: flex;
}
.content-box {
  flex: 1;
}
.box {
  margin-top: 20px;
}
.title {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  position: relative;
}
.title::before {
  content: "";
  position: absolute;
  width: 3px;
  height: 20px;
  background-color: #6435E8;
  left: -20px;
  top: 4px;
}
.info {
  display: flex;
  line-height: 28px;
}
.info > img {
  width: 80px;
  height: 80px;
  margin-top: 8px;
}
.info > label {
  width: 135px;
  text-align: right;
}
.info > span {
  width: 315px;
  word-break: break-all;
}
</style>